/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */

import tabPageMinix from '../../tabPageMinix';
import pieEcharts from '@/components/app/pieEcharts/index.vue';
import barEcharts from '@/components/app/barEcharts/index.vue';

export default {
    name: 'spajtj',
    mixins: [tabPageMinix],
    components: {pieEcharts, barEcharts},
    data() {
        return {
            hsfyzxajglTotal: {},
            // 海事法院执行案件概览
            tableHsfyzxajgl: [],
            // 执行标的物种类
            zxbdwzData: [],
            // 执行标的物金额
            zxbdwjeData: []
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            const _searchData = this.$parent.searchData;
            const _this = this;

            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.szsjtj.countForZxajtj,

                params: _searchData
            })
                .then((res) => {
                    _this.hsfyzxajglTotal = res.data.hsfyzxajglTotal;
                    _this.zxbdwzData = res.data.zxbdwzData;
                    _this.zxbdwjeData = res.data.zxbdwjeData;
                    _this.tableHsfyzxajgl = [
                        {
                            'title': '大连海事法院',
                            'name': '辽宁',
                            'xs': res.data.tableHsfyzxajgl['大连海事法院'] ? res.data.tableHsfyzxajgl['大连海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['大连海事法院'] ? res.data.tableHsfyzxajgl['大连海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['大连海事法院'] ? res.data.tableHsfyzxajgl['大连海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['大连海事法院'] ? res.data.tableHsfyzxajgl['大连海事法院'].wjajs : 0
                        },
                        {
                            'title': '天津海事法院',
                            'name': '天津',
                            'xs': res.data.tableHsfyzxajgl['天津海事法院'] ? res.data.tableHsfyzxajgl['天津海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['天津海事法院'] ? res.data.tableHsfyzxajgl['天津海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['天津海事法院'] ? res.data.tableHsfyzxajgl['天津海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['天津海事法院'] ? res.data.tableHsfyzxajgl['天津海事法院'].wjajs : 0
                        },
                        {
                            'title': '青岛海事法院',
                            'name': '山东',
                            'xs': res.data.tableHsfyzxajgl['青岛海事法院'] ? res.data.tableHsfyzxajgl['青岛海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['青岛海事法院'] ? res.data.tableHsfyzxajgl['青岛海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['青岛海事法院'] ? res.data.tableHsfyzxajgl['青岛海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['青岛海事法院'] ? res.data.tableHsfyzxajgl['青岛海事法院'].wjajs : 0
                        },
                        {
                            'title': '南京海事法院',
                            'name': '江苏',
                            'xs': res.data.tableHsfyzxajgl['南京海事法院'] ? res.data.tableHsfyzxajgl['南京海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['南京海事法院'] ? res.data.tableHsfyzxajgl['南京海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['南京海事法院'] ? res.data.tableHsfyzxajgl['南京海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['南京海事法院'] ? res.data.tableHsfyzxajgl['南京海事法院'].wjajs : 0
                        },
                        {
                            'title': '上海海事法院',
                            'name': '上海',
                            'xs': res.data.tableHsfyzxajgl['上海海事法院'] ? res.data.tableHsfyzxajgl['上海海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['上海海事法院'] ? res.data.tableHsfyzxajgl['上海海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['上海海事法院'] ? res.data.tableHsfyzxajgl['上海海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['上海海事法院'] ? res.data.tableHsfyzxajgl['上海海事法院'].wjajs : 0
                        },
                        {
                            'title': '武汉海事法院',
                            'name': '湖北',
                            'xs': res.data.tableHsfyzxajgl['武汉海事法院'] ? res.data.tableHsfyzxajgl['武汉海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['武汉海事法院'] ? res.data.tableHsfyzxajgl['武汉海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['武汉海事法院'] ? res.data.tableHsfyzxajgl['武汉海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['武汉海事法院'] ? res.data.tableHsfyzxajgl['武汉海事法院'].wjajs : 0
                        },
                        {
                            'title': '宁波海事法院',
                            'name': '浙江',
                            'xs': res.data.tableHsfyzxajgl['宁波海事法院'] ? res.data.tableHsfyzxajgl['宁波海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['宁波海事法院'] ? res.data.tableHsfyzxajgl['宁波海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['宁波海事法院'] ? res.data.tableHsfyzxajgl['宁波海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['宁波海事法院'] ? res.data.tableHsfyzxajgl['宁波海事法院'].wjajs : 0
                        },
                        {
                            'title': '厦门海事法院',
                            'name': '福建',
                            'xs': res.data.tableHsfyzxajgl['厦门海事法院'] ? res.data.tableHsfyzxajgl['厦门海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['厦门海事法院'] ? res.data.tableHsfyzxajgl['厦门海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['厦门海事法院'] ? res.data.tableHsfyzxajgl['厦门海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['厦门海事法院'] ? res.data.tableHsfyzxajgl['厦门海事法院'].wjajs : 0
                        },
                        {
                            'title': '广州海事法院',
                            'name': '广东',
                            'xs': res.data.tableHsfyzxajgl['广州海事法院'] ? res.data.tableHsfyzxajgl['广州海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['广州海事法院'] ? res.data.tableHsfyzxajgl['广州海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['广州海事法院'] ? res.data.tableHsfyzxajgl['广州海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['广州海事法院'] ? res.data.tableHsfyzxajgl['广州海事法院'].wjajs : 0
                        },
                        {
                            'title': '北海海事法院',
                            'name': '广西',
                            'xs': res.data.tableHsfyzxajgl['北海海事法院'] ? res.data.tableHsfyzxajgl['北海海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['北海海事法院'] ? res.data.tableHsfyzxajgl['北海海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['北海海事法院'] ? res.data.tableHsfyzxajgl['北海海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['北海海事法院'] ? res.data.tableHsfyzxajgl['北海海事法院'].wjajs : 0
                        },
                        {
                            'title': '海口海事法院',
                            'name': '海南',
                            'xs': res.data.tableHsfyzxajgl['海口海事法院'] ? res.data.tableHsfyzxajgl['海口海事法院'].xsajs : 0,
                            'jc': res.data.tableHsfyzxajgl['海口海事法院'] ? res.data.tableHsfyzxajgl['海口海事法院'].jcajs : 0,
                            'yj': res.data.tableHsfyzxajgl['海口海事法院'] ? res.data.tableHsfyzxajgl['海口海事法院'].yjajs : 0,
                            'wj': res.data.tableHsfyzxajgl['海口海事法院'] ? res.data.tableHsfyzxajgl['海口海事法院'].wjajs : 0
                        }
                    ];
                });
        }
    }
};

